<template>
  <div class="Agreement">
    <div class="l-container">

      <div style="display: flex; align-items: center; padding: 5px 0">
        <template v-if="agreement.student">
          <h1 class="m-name">[{{agreement.id}}] {{agreement.student.f_name}} {{agreement.student.l_name}}({{agreement.student.f_name_kana}} {{agreement.student.l_name_kana}}) 様</h1>
        </template>

        <transition name="loading" mode="out-in">
          <template v-if="agreement.student">
            <template v-if="agreement.student.family">
              <router-link :to="{ name: 'familyindex', params: { id: agreement.student.family.id }, exact: true }">
                <i class="fa fa-home"></i>
              </router-link>
            </template>
          </template>
        </transition>

        <transition name="loading" mode="out-in">
          <template v-if="agreement.student">
            <router-link :to="{ name: 'studentindex', params: { id: agreement.student.id }, exact: true }">
              <i class="fa fa-user-circle"></i>
            </router-link>
          </template>
        </transition>

        <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
          <div>
            <span v-for="list in agreement.agreement_tags" :key="list.id">
              <tag v-bind:style="{ 'backgroundColor': list.tag.color }">
                <i @click="deleteAgreementTag(list)" class="fa fa-fw fa-times"></i>
                {{list.tag.name}}
              </tag>
            </span>
          </div>

          <div class="tagInput">
            <i class="fa fa-tag"></i>
            <multiselect v-model="tag" :options="tags" label="name" :show-labels="false" placeholder="タグ追加"></multiselect>
            <i @click="postAgreementTag" class="fa fa-plus"></i>
          </div>
        </template>

      </div>

      <section-navi>
        <section-item>
          <router-link :to="{ name: 'agreementindex', params: { id: agreement.id }, exact: true }" exact>データ</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'agreementpdf', params: { id: agreement.id }, exact: true }">PDF</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'agreementhistory', params: { id: agreement.id }, exact: true }">対応履歴</router-link>
        </section-item>
        <section-item @click.native="getVersionsAgreement(agreement.id)">
          <router-link :to="{ name: 'agreementdiff', params: { id: agreement.id }, exact: true }">変更履歴</router-link>
        </section-item>
      </section-navi>

      <router-view :agreement="agreement" :condition="condition" :edit_id="edit_id"></router-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      edit_id: {
        agreement_id: '',
        list_id: ''
      },
      condition: {
        condition: false
      },

      tag: ''
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },

    // users () {
    //   return this.$store.getters.users
    // },

    agreement () {
      return this.$store.getters.agreement
    },

    tags () {
      return this.$store.getters.tags
    }
  },

  methods: {
    getAgreement (id) {
      Vue.delete(this.agreement, 'agreementsupports')
      this.$store.dispatch('getAgreement', id)
    },

    getVersionsAgreement (id) {
      this.$store.dispatch('getVersionsAgreement', id)
    },

    // getUsers () {
    //   this.$store.dispatch('getUsers')
    // },

    getTags () {
      this.$store.dispatch('getTags')
    },

    postAgreementTag () {
      if (this.tag === '') {
        return alert('タグを選んでください。')
      } else {
        this.$store.dispatch('postAgreementTag', {
          this: this,
          tag: this.tag
        })
      }
    },

    deleteAgreementTag (list) {
      this.$store.dispatch('deleteAgreementTag', {
        this: this,
        list: list
      })
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAgreement(to.params.id)
      // vm.getUsers(to)
      vm.getTags(to)
    })
  },

  mounted () {
  },

  route: {
  }
}
</script>

<style lang="scss" scoped>
.tagInput {
  display: flex;
  border-radius: 15px;
  height: 27px;
}
.fa-tag, .fa-plus {
  font-size: 15px;
  padding: 5px;
  height: 27px;
}
.fa-user-circle {
  font-size: 30px;
}
</style>

<style lang="scss">
.Agreement {
  .multiselect {
    min-height: 26px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: 1px solid #ccc;
    border-radius: 5px;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    width: 25px;
    padding: 4px 4px;
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// Agreement.vue?be192b6c